import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface MemberSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function MemberSearchInput({ value, onChange, placeholder = "ابحث عن شخص..." }: MemberSearchInputProps) {
  return (
    <div className="relative">
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-10 pr-4"
      />
      <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
    </div>
  );
}